"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconShuffleSmart = Experimental__IconShuffleSmart;
exports.IconShuffleSmart = IconShuffleSmart;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconShuffleSmart/index.tsx)
 */
function IconShuffleSmart(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'m7.5 10.723.788.938A3.75 3.75 0 0 0 11.16 13h1.947l-1.017 1.018a.75.75 0 1 0 1.06 1.06l2.829-2.828-2.829-2.828a.75.75 0 1 0-1.06 1.06l1.018 1.018H11.16a2.25 2.25 0 0 1-1.724-.804l-.957-1.14-.98 1.167z\'/><path d=\'M12.09.922a.75.75 0 0 1 1.061 0L15.98 3.75l-2.83 2.828a.75.75 0 1 1-1.06-1.06L13.109 4.5H11.16a2.25 2.25 0 0 0-1.724.804L3.264 12.66A3.75 3.75 0 0 1 .391 14H0v-1.5h.391a2.25 2.25 0 0 0 1.724-.804L8.288 4.34A3.75 3.75 0 0 1 11.16 3h1.947L12.09 1.982a.75.75 0 0 1 0-1.06zM.88 3.319C2.255 2.874 2.976 1.787 3.297.874c.036-.102.37-.102.406 0 .321.913 1.042 2 2.417 2.445.103.033.103.329 0 .362-1.375.445-2.096 1.532-2.417 2.445-.036.102-.37.102-.406 0-.321-.913-1.042-2-2.417-2.445-.103-.033-.103-.329 0-.362z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M18.788 3.702a1 1 0 1 1 1.414-1.415L23.914 6l-3.712 3.712a1 1 0 0 1-1.414-1.414L20.086 7h-1.518a5 5 0 0 0-3.826 1.78l-7.346 8.73a7 7 0 0 1-5.356 2.494H1v-2h1.04a5 5 0 0 0 3.826-1.781l7.345-8.73A7 7 0 0 1 18.569 5h1.518l-1.298-1.298z\'/><path d=\'m13.211 16.508-1.178-1.401 1.306-1.553 1.403 1.666A5 5 0 0 0 18.568 17h1.518l-1.298-1.297a1 1 0 1 1 1.414-1.414L23.914 18l-3.712 3.712a1 1 0 0 1-1.414-1.414L20.086 19h-1.518a7 7 0 0 1-5.357-2.493zM.986 6.33c2.635-.663 3.87-2.77 4.32-4.351.034-.116.354-.116.387 0 .45 1.581 1.686 3.688 4.322 4.35.117.03.117.312 0 .341-2.636.663-3.871 2.77-4.322 4.351-.033.116-.353.116-.386 0C4.857 9.44 3.62 7.333.986 6.671c-.117-.03-.117-.312 0-.341z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconShuffleSmart is deprecated and will be archived soon. Use IconShuffleSmart instead.
 */
function Experimental__IconShuffleSmart(props) {
  return /*#__PURE__*/_react["default"].createElement(IconShuffleSmart, props);
}